import { byPrefixAndName } from '@awesome.me/kit-f16c5d7bca/icons'
import { Badge, Box, Button, Divider, IconButton, VStack } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { motion } from 'framer-motion'
import { useSelector } from 'react-redux'
import { variants } from '../../configs/mfFramer'
import MFNavAvatarMenu from './MFNav.AvatarMenu'
import { useMFNav } from './MFNav.Provider'
import MFNavNavItem from './MFNav.SidebarNavItem'

/**
 * MFNavSidebarFooter component renders the footer section of the navigation sidebar.
 *
 * @returns {JSX.Element} The rendered sidebar footer component.
 */
export default function MFNavSidebarFooter() {
  const {
    menu: {
      state: { trueDockState },
      size
    },
    current: { admin }
  } = useMFNav()

  /** @type {import('../../redux/storeConfig/slices/slice.integrations/integrations.types').FeaturebaseSlice['changelog']} */
  const featurebaseChangelog = useSelector(state => state.integrations.featurebase.changelog)

  return (
    <VStack as="footer" w="full">
      <VStack w="full" p="3" spacing="0">
        <MFNavNavItem
          id="support"
          title="Help & Support"
          icon={<FontAwesomeIcon icon={byPrefixAndName['fad']['square-question']} />}
          link={{
            type: 'external',
            url: `https://support.marketfuel.com/`
          }}
        />
        {!trueDockState ? (
          <Button
            variant="ghost"
            colorScheme="neutral"
            fontSize="sm"
            justifyContent="flex-start"
            gap="2"
            w="100%"
            aria-label="Latest Changes"
            key="changelog"
            leftIcon={<FontAwesomeIcon icon={byPrefixAndName['fad']['bullhorn']} />}
            data-featurebase-changelog
            onClick={() => size.toggle('full')}
          >
            Latest Changes
            {featurebaseChangelog.unreadChanges > 0 && (
              <Badge
                as={motion.span}
                variants={variants.pulse(1.1)}
                initial="initial"
                animate="animate"
                colorScheme="secondary"
                borderRadius="full"
                fontSize="xx-small"
                lineHeight="xl"
              >
                new
              </Badge>
            )}
          </Button>
        ) : (
          <Box position="relative">
            <IconButton
              icon={<FontAwesomeIcon icon={byPrefixAndName['fad']['bullhorn']} />}
              variant="ghost"
              colorScheme="neutral"
              fontSize="sm"
              justifyContent="center"
              gap="2"
              aria-label="Latest Changes"
              data-featurebase-changelog
              onClick={() => size.toggle('full')}
            />
            {featurebaseChangelog.unreadChanges > 0 && (
              <Badge
                as={motion.span}
                variants={variants.pulse(1.5)}
                initial="initial"
                animate="animate"
                top="40%"
                left="75%"
                h="1.5                          "
                w="1.5"
                p="0"
                position="absolute"
                colorScheme="secondary"
                borderRadius="full"
              />
            )}
          </Box>
        )}
        <MFNavNavItem
          id="feedback"
          title="Give Us Feedback"
          icon={<FontAwesomeIcon icon={byPrefixAndName['fad']['message-dots']} />}
          link={{
            type: 'external',
            url: `https://feedback.marketfuel.com?jwt=${admin.featurebase_authentication_token}`
          }}
        />
      </VStack>
      <Divider my="0" />
      <MFNavAvatarMenu buttonType="responsive" condition={trueDockState} p="3" />
    </VStack>
  )
}
